var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"map"}},[_c('BreakdownInfoList',{attrs:{"obj":_vm.data.zones.features,"selectedItemId":_vm.data.selectionData[0]?.props.osm_id},on:{"go-to-breakdown":_vm.goToBreakdown,"toggle-info-list":_vm.toggleSidebarPanels}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }